import { api } from '../core/api';
import { MonitoredCounter } from '../../types/app/monitoredCounter.types';

export const monitoredCounterGetList = (parentId: number) =>
  api
    .get<MonitoredCounter[]>(`MonitoredCounter/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const monitoredCounterGetById = (id: number) =>
  api.get<MonitoredCounter>(`MonitoredCounter/GetById?id=${id}`).then((res) => res.data);

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCounter/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
